import record from './record'
import playback from './playback'

const videoPlay = {
  path: 'videoPlay/:courseId',
  component: resolve => require(['../../../pages/teacher/videoplay'], resolve),
  children: [
    record,
    playback
  ]
}
export default videoPlay



// WEBPACK FOOTER //
// ./src/router/teacher/videoplay/index.js